import {
  GET_FACULTIES,
  GET_FACULTIES_FAIL,
  GET_FACULTIES_SUCCESS,
  ADD_NEW_FACULTY,
  ADD_FACULTY_SUCCESS,
  ADD_FACULTY_FAIL,
  UPDATE_FACULTY,
  UPDATE_FACULTY_SUCCESS,
  UPDATE_FACULTY_FAIL,
  DELETE_FACULTY,
  DELETE_FACULTY_SUCCESS,
  DELETE_FACULTY_FAIL,
  
} from "./actionTypes";

export const getFaculties = () => ({
  type: GET_FACULTIES,
})

export const getFacultiesSuccess = faculties => ({
  type: GET_FACULTIES_SUCCESS,
  payload: faculties,
})

export const getFacultiesFail = error => ({
  type: GET_FACULTIES_FAIL,
  payload: error,
})

export const addNewFaculty = data => ({
  type: ADD_NEW_FACULTY,
  payload: data,
})

export const addFacultySuccess = faculty => ({
  type: ADD_FACULTY_SUCCESS,
  payload: faculty,
})

export const addFacultyFail = error => ({
  type: ADD_FACULTY_FAIL,
  payload: error,
})

export const updateFaculty = faculty => ({
  type: UPDATE_FACULTY,
  payload: faculty,
})

export const updateFacultySuccess = faculty => ({
  type: UPDATE_FACULTY_SUCCESS,
  payload: faculty,
})

export const updateFacultyFail = error => ({
  type: UPDATE_FACULTY_FAIL,
  payload: error,
})

export const deleteFaculty = data => ({
  type: DELETE_FACULTY,
  payload: data,
})

export const deleteFacultySuccess = data => ({
  type: DELETE_FACULTY_SUCCESS,
  payload: data,
})

export const deleteFacultyFail = error => ({
  type: DELETE_FACULTY_FAIL,
  payload: error,
})

